import React, {useState, useContext, useEffect} from "react";
import {RealmContext, TokenContext, TreeContext} from "../../Store";

import Slide from "@mui/material/Slide";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

import Dialog from "@mui/material/Dialog";

import DataComponentService from "../../../services/DataComponentService";

import {trackPromise} from "react-promise-tracker";
import Button from "@mui/material/Button";
import {Form, Formik} from "formik";

import UploadService from "../../../services/upload-files.service";

import UploadDialog from "../Dataobjects/UploadDialog";
import {confirmWrapper} from "../../../shared/confirm";
import TreeComponentTypeService from "../../../services/TreeComponentTypeService";

import DataobjectService from "../../../services/DataobjectService";
import AttachmentList from '../../../shared/AttachmentList';
import DataComponentButtonToolbar from '../Datacomponents/DataComponentButtonToolbar';
import DataComponentList from "../Datacomponents/DataComponentList";

import {useStylesDialog} from "../../../shared/useStyleDialog";

const initialValues = {
    name: '',
    number: '',
    label: '',
    description: '',
    componentAttributeList: [],
    guid: '',
    id: null,
    position: '',
    deactivated: 0
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

function DataComponentDialog({dataObjectSelected, setDataComponentCopyFormDialogOpen, DataComponentCopyFormDialogOpen, componentSelected, componentType, attributeList, setAttributeList, realestateobjectGuid, handleActivateClick, handleDeactivateClick, saveObject, reloadComponentList, userProject}) {
    const classesDialog = useStylesDialog();

    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);
    const [formValues, setFormValues] = useState(null);

    const [myComponentType, setMyComponentType] = useState({});

    const tree = useContext(TreeContext);
    const treeItemsState = tree.items;
    const setTreeItemsState = tree.setItems;
    const [value, setValue] = React.useState(null);
    const [parentComponentValue, setParentComponentValue] = React.useState(null);

    const [fileInfos, setFileInfos] = useState([]);

    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

    const [newRealestateobjectGuid, setNewRealestateobjectGuid] = useState(null);
    const [realestateobjectSubValue, setRealestateobjectSubValue] = useState(null);

    const [componentFlatListValues, setComponentFlatListValues] = useState([]);
    let myAttributList = componentType?.attribute;
    let attributes = componentSelected.componentAttributeList;

    const componentFlatList = [];

    useEffect(() => {
        setFormValues(null);
        if(realestateobjectGuid) {
            setNewRealestateobjectGuid(realestateobjectGuid);
        } else {
            setNewRealestateobjectGuid(componentSelected.realestateobjectGuid);
        }

        if ((!treeItemsState || treeItemsState.length === 0) && (token && token !== 'Kein Token generiert!')) {
            TreeComponentTypeService.getTreeData(token, realm)
                .then((res) => {
                    setTreeItemsState(res.data);
                })
        }

        if(componentSelected && componentSelected.name) {
            const savedValues = {
                name: componentSelected.name,
                number: componentSelected.number ? componentSelected.number : '',
                label: componentSelected.label ? componentSelected.label : '',
                description: componentSelected.description ? componentSelected.description : '',
                guid: null,
                id: null,
                deactivated: componentSelected.deactivated,
                position: componentSelected.position ? componentSelected.position : '',
                geom: componentSelected.geom ? componentSelected.geom : ''
            }
            if(componentSelected.parentComponent) {
                const myParentComponent = {};
                myParentComponent.name = componentSelected.parentComponent;
                myParentComponent.id = componentSelected.parentComponentId;
                myParentComponent.guid = componentSelected.parentComponentGuid;
                myParentComponent.title = componentSelected.parentComponent + ' - ' + componentSelected.realestateobjectName;
                setParentComponentValue(myParentComponent);
            } else {
                setParentComponentValue(null);
            }

            if(myAttributList) {
                myAttributList.forEach((item) => {
                    savedValues['attr_' + item.attribute_id] = item.value ? item.value : '';
                    if (item.name === 'Bezeichnung') {
                        savedValues['attr_' + item.attribute_id] = componentSelected?.name ? componentSelected.name : componentType?.name;
                    }
                    if (item.name === 'Nummer') {
                        savedValues['attr_' + item.attribute_id] = componentSelected?.number ? componentSelected?.number : '';
                    }
                    if (item.name === 'Kennzeichen') {
                        savedValues['attr_' + item.attribute_id] = componentSelected?.label ? componentSelected?.label : '';
                    }
                    if (item.name === 'Ort') {
                        savedValues['attr_' + item.attribute_id] = componentSelected?.position ? componentSelected?.position : '';
                    }
                    if (item.name === 'Beschreibung') {
                        savedValues['attr_' + item.attribute_id] = componentSelected?.description ? componentSelected?.description: '';
                    }
                })
            }

            if(componentSelected.componentAttributeList) {
                componentSelected.componentAttributeList.forEach((item) => {
                    if(item.mmsAttributeId) {
                        savedValues['attr_' + item.mmsAttributeId] = item.value;
                        if (item.label === 'Bezeichnung') {
                            savedValues['attr_' + item.mmsAttributeId] = componentSelected?.name ? componentSelected.name : componentType?.name;
                        }
                        if (item.label === 'Nummer') {
                            savedValues['attr_' + item.mmsAttributeId] = componentSelected?.number ? componentSelected?.number : "";
                        }
                        if (item.label === 'Kennzeichen') {
                            savedValues['attr_' + item.mmsAttributeId] = componentSelected?.label ? componentSelected?.label : "";
                        }
                        if (item.label === 'Ort') {
                            savedValues['attr_' + item.mmsAttributeId] = componentSelected?.position ? componentSelected?.position : "";
                        }
                        if (item.label === 'Beschreibung') {
                            savedValues['attr_' + item.mmsAttributeId] = componentSelected?.description ? componentSelected?.description : "";
                        }
                    } else {
                        savedValues['attribute_tenant_' + item.id] = item.value ? item.value : "";
                    }
                });

                if(!dataObjectSelected || (dataObjectSelected instanceof Array && dataObjectSelected.length === 0)) {
                    DataobjectService.getRealestateObject(token, realm, componentSelected.realestateobjectGuid)
                        .then(result => {
                            const item = result.data
                            setRealestateobjectsValues(item)
                            const myItem = {};
                            myItem.name = item.name;
                            myItem.id = item.id;
                            myItem.guid = item.guid;
                            myItem.title = item.number + ' - ' + item.name;
                            myItem.key = item.guid;
                            setRealestateobjectSubValue(myItem);
                        });
                }
                DataComponentService.getAllComponentsToRealestateobject(token, realm, componentSelected.realestateobjectGuid)
                    .then(async(result) => {
                        await setRealestateComponents(result.data);
                        setComponentFlatListValues(componentFlatList)
                    });
            }

            const myTempComponentType = {};
            myTempComponentType.objecttypeId = componentType.objecttype_id;
            myTempComponentType.name = componentType.name;
            myTempComponentType.mmsCode = componentType.code;
            myTempComponentType.mmsCafmId = componentType.global_id;
            myTempComponentType.mmsGlobalId = componentType.global_id;
            setMyComponentType(myTempComponentType);

            setFormValues(savedValues);
            setFileInfos([]);

        } else {
            if(componentType?.length == 0) {
                setFileInfos([]);
            }
            setFileInfos([]);
            if((dataObjectSelected.realestateobjectType || dataObjectSelected.realestateobjectTypeGuid) && dataObjectSelected.guid) {
                DataComponentService.getComponentsToRealestateobject(token, realm, dataObjectSelected.guid)
                    .then(async (result) => {
                        await setRealestateComponents(result.data);
                        setComponentFlatListValues(componentFlatList)
                    });
            }
        }
        if(dataObjectSelected && dataObjectSelected.guid) {
            const item = dataObjectSelected;
            setRealestateobjectsValues(item).then(()=> {
                const myItem = {};
                myItem.name = item.name;
                myItem.id = item.id;
                myItem.guid = item.guid;
                myItem.title = item.number + ' - ' + item.name;
                myItem.key = item.guid;
                setRealestateobjectSubValue(myItem);
            })
        }

    }, [componentSelected, componentType, attributeList, realm, token, treeItemsState, setTreeItemsState, setNewRealestateobjectGuid, realestateobjectGuid]);


    const [liegenschaftSubFlatList, setLiegenschaftSubFlatList] = useState([]);
    const lsfl = [];


    function convert3(item) {
        const myItem = {};
        myItem.name = item.name;
        myItem.id = item.id;
        myItem.guid = item.guid;
        myItem.title = item.number + ' - ' + item.name;
        myItem.key = item.guid;
        lsfl.push(myItem);
    }

    const setRealestateobjectsValues = async(val) => {
        if (val && val.guid) {
            const objsParents = await DataobjectService.listrealestateobjectparents(token, realm, val.guid);
            const objsSiblings = await DataobjectService.listrealestateobjectsiblings(token, realm, val.guid);
            const objsChildren = await DataobjectService.listrealestateobjectchildren(token, realm, val.guid);
            let objects = [];
            if(objsParents?.data && objsParents.data instanceof Array) {
                objects = [...objsParents.data]
            }
            if(objsSiblings?.data && objsSiblings.data instanceof Array) {
                objects = [...objects, ...objsSiblings.data];
            }
            if(objsChildren?.data && objsChildren.data instanceof Array) {
                objects = [...objects, ...objsChildren.data];
            }

            const uniqueIds = [];
            const uniqueObjects = objects.filter(element => {
                const isDuplicate = uniqueIds.includes(element.guid);
                if (!isDuplicate) {
                    uniqueIds.push(element.guid);
                    return true;
                }
                return false;
            });

            uniqueObjects.forEach(item => {
                convert3(item)
            });

            setLiegenschaftSubFlatList(lsfl)
        }
    }

    const setRealestateobjectSubValues = async(val) => {
        setRealestateobjectSubValue(val)
        if(val && val.guid) {
            setNewRealestateobjectGuid(val.guid)
        }
    }

    const setRealestateComponents = async(val) => {
        if(val && val instanceof Array) {
            val.forEach(item => {
                convertComponentList(item)
            });
        }
    }

    function convertComponentList(item) {
        const myItem = {};
        myItem.name = item.name;
        myItem.id = item.id;
        myItem.guid = item.guid;
        myItem.title = item.name + ' - ' + item.realestateobjectName;
        myItem.key = item.guid;
        componentFlatList.push(myItem);
    }

    const setComponentTypeValue = async(val) => {
        setValue(val);
        if(val) {
            const myTempComponentType = {};
            myTempComponentType.objecttypeId = val.id;
            myTempComponentType.name = val.name;
            myTempComponentType.mmsCode = val.code;
            myTempComponentType.mmsCafmId = val.cafmId;
            myTempComponentType.mmsGlobalId = val.globalId;
            setMyComponentType(myTempComponentType);
            await trackPromise(
                (async () => {
                    const result = await DataComponentService.getComponentTypeByCode(token, realm, val.code);
                    myAttributList = result.data[0].attribute;
                    const myArray = DataComponentService.fillEmptyAttributList(myAttributList);
                    setAttributeList(myArray);

                    const initialFormValues = {
                        name: '',
                        number: '',
                        label: '',
                        description: '',
                        guid: '',
                        id: null,
                        deactivated: 0,
                        position: '',
                        geom: ''
                    }
                    myArray.forEach((item) => {
                        initialFormValues[item.name] = ''
                    });
                    setFormValues(initialFormValues);
                })()
            );
        }
    }


    const deactivateClick = async (event) => {
        if (await confirmWrapper('Soll das Bauteil wirklich deaktiviert werden?')) {
            handleDeactivateClick(componentSelected, event);
        }
    }

    const activateClick = (event) => {
        handleActivateClick(componentSelected, event);
    }

    const afterUploadWork = async () => {
        const files = await UploadService.getFiles(componentSelected.id, token, realm, 'component');
        setFileInfos(files.data);
        await reloadComponentList();
    }

    const closeWindow = () => {
        setDataComponentCopyFormDialogOpen(false);
    }

    return (
        <>
            <Dialog
                className={classesDialog.dialog}
                open={DataComponentCopyFormDialogOpen}
                onClose={() => closeWindow()}
                TransitionComponent={Transition}
                fullScreen
            >
                <Formik
                    enableReinitialize
                    initialValues={formValues || initialValues}
                    onSubmit={async (values, { setSubmitting }) => {
                        setSubmitting(true);

                        const objectAttributes = [];
                        let myName = values.name;
                        let myNumber = values.number;
                        let myMark = values.label;
                        let myDescription = values.description;
                        let myPosition = newRealestateobjectGuid;
                        let myGeom = values.geom;
                        Object.entries(values).map(([key, value]) => {
                            if(key.substring(0, 5) === 'attr_') {
                                const arr = key.split('_');
                                const mmsAttributeId = arr[1];
                                const attr = {};
                                attr.mms_attribut_id = mmsAttributeId;
                                attr.value = value ? value : "";

                                attributeList.map((item) => {
                                    if(item.name === key) {
                                        attr.name = item.label;
                                        attr.label = item.label;
                                        attr.attributeType = item.attributeType ? item.attributeType : item.type;
                                        attr.dataType = item.dataType ? item.dataType : item.data_type;
                                    }
                                    if(item.name === key) {
                                        if (item.label === 'Bezeichnung') {
                                            myName = attr.value;
                                        } else if (item.label === 'Nummer') {
                                            myNumber = attr.value;
                                        } else if (item.label === 'Kennzeichen') {
                                            myMark = attr.value;
                                        } else if (item.label === 'Ort') {
                                            myPosition = newRealestateobjectGuid;
                                        } else if (item.label === 'Beschreibung') {
                                            myDescription = attr.value;
                                        }
                                    }
                                });
                                objectAttributes.push(attr);
                            } else if(key.substring(0, 16) === 'attribute_tenant') {
                                const arr = key.split('_');
                                const attributeId = arr[2];
                                const attr = {}
                                attr.id = attributeId;
                                attr.value = value ? value : "";

                                attributes.forEach((item) => {
                                    if(item.id.toString() === attributeId.toString()) {
                                        attr.name = item.name;
                                    }
                                });
                                objectAttributes.push(attr);
                            }
                        });


                        const data = {
                            name: myName,
                            description: myDescription,
                            guid: values.guid ? values.guid : "",
                            id: values.id,
                            label: myMark,
                            number: myNumber,
                            position: myPosition,
                            realestateobjectGuid: newRealestateobjectGuid,
                            parentComponentGuid: parentComponentValue?.guid,
                            geom: myGeom,
                            componentType: {
                                objecttypeId: myComponentType?.objecttypeId,
                                name: myComponentType?.name,
                                mmsCode: myComponentType?.mmsCode,
                                mmsCafmId: myComponentType?.mmsCafmId,
                                mmsGlobalId: myComponentType?.mmsGlobalId,
                                guid: myComponentType?.guid
                            }
                        };

                        await saveObject(data, objectAttributes);

                        setSubmitting(false);
                        closeWindow();
                    }}
                >
                    <Form>
                        <AppBar className={classesDialog.appBar}>
                            <Toolbar>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={() => closeWindow()}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" className={classesDialog.title}>
                                    Bauteil kopieren
                                </Typography>
                                <Button
                                    type="submit"
                                    color="inherit"
                                >
                                    Speichern
                                </Button>
                            </Toolbar>
                        </AppBar>

                        <DataComponentList
                            componentSelected={componentSelected}
                            attributeList={attributeList}
                            treeItemsState={treeItemsState}
                            setComponentTypeValue={setComponentTypeValue}
                            value={value}
                            liegenschaftSubFlatList={liegenschaftSubFlatList}
                            setRealestateobjectSubValues={setRealestateobjectSubValues}
                            realestateobjectSubValue={realestateobjectSubValue}
                            componentFlatListValues={componentFlatListValues}
                            setParentComponentValue={setParentComponentValue}
                            parentComponentValue={parentComponentValue}
                        />

                        <DataComponentButtonToolbar
                            componentSelected={componentSelected}
                            deactivateClick={deactivateClick}
                            activateClick={activateClick}
                            setUploadDialogOpen={setUploadDialogOpen}
                        />
                        <AttachmentList
                            fileInfos={fileInfos}
                            setFileInfos={setFileInfos}
                            componentSelected={componentSelected}
                            reloadComponentList={reloadComponentList}
                            theRealm={realm}
                        />

                    </Form>
                </Formik>

            </Dialog>
            <UploadDialog
                dataObjectSelected={componentSelected}
                setUploadDialogOpen={setUploadDialogOpen}
                uploadDialogOpen={uploadDialogOpen}
                callbackFunc={afterUploadWork}
            />
        </>
    );
}

export default DataComponentDialog;
